// extracted by mini-css-extract-plugin
export default {"root":"LazyLoader_root__GHnMG"};